export default __webpack_public_path__ + "static/media/divider.3212d85f.svg";